module.exports = __webpack_public_path__ + "img/scorpione.13cfa6fb.png";